import React from "react";

type Props = {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  showTagline?: boolean;
};

const sizeMap = {
  sm: { img: 48, text: "text-lg", tagline: "text-[10px]" },
  md: { img: 64, text: "text-2xl", tagline: "text-xs" },
  lg: { img: 96, text: "text-4xl", tagline: "text-sm" },
  // FIX LOGO BROWSER (Ago 2026): variante "xl" per le pagine auth desktop —
  // logo più grande e centrato sopra il testo (prima items-start lo
  // spostava a sinistra rompendo l'allineamento su browser).
  xl: { img: 128, text: "text-5xl", tagline: "text-base" },
};

export default function BrandLogo({
  size = "md",
  className = "",
  showTagline = false,
}: Props) {
  const s = sizeMap[size];

  return (
    <div
      className={`flex flex-col items-center gap-2 select-none ${className}`}
    >
      {/* Official RideConnect logo — rounded image */}
      <img
        src="/icon-512.png"
        alt="RideConnect logo"
        width={s.img}
        height={s.img}
        style={{
          borderRadius: "22%",
          filter: "drop-shadow(0 8px 24px rgba(0,0,0,0.55))",
          objectFit: "contain",
        }}
        draggable={false}
      />

      {/* Wordmark */}
      <div
        className={`font-extrabold tracking-tight text-white leading-none ${s.text}`}
        style={{ fontFamily: "'Inter', sans-serif", letterSpacing: "-0.02em" }}
      >
        Ride<span style={{ color: "#F97316" }}>Connect</span>
      </div>

      {/* Tagline — hidden by default to keep it clean */}
      {showTagline && (
        <div
          className={`text-neutral-400 tracking-widest uppercase ${s.tagline}`}
          style={{ letterSpacing: "0.2em" }}
        >
          Connect. Track. Explore.
        </div>
      )}
    </div>
  );
}
